module.exports = __webpack_public_path__ + "static/media/bg1.b1648ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/editor/layout/addons/props/components/bgTheme/bg/bg1.jpg
// module id = 3320
// module chunks = 0